<template>
  <modal
    :show.sync="openModal"
    modal-classes="modal-dialog-centered modal-lg modalflight"
    body-classes=""
    @close="closeSurchargeModal"
    no-close-on-backdrop
  >
    <template slot="header">
      <h4 class="subtitle">Especial Conditions</h4>
    </template>

    <div class=" pt-4 forms">
      <div class="row">
        <div class="col-lg-6 col-sm-8 col-8">
          <WSelect
            placeholder="Select Event"
            v-model="surcharge.type"
            id="event_type"
            name="event_type"
            filterable
            v-bind:class="{ 'is-invalid': $v.surcharge.type.$error }"
            markrequired
            label="Type Event"
          >
            <el-option
              v-for="option in SURCHARGE_TYPES"
              :value="option.value"
              :label="option.label"
              :key="option.label"
            ></el-option>
          </WSelect>
          <small class="invalid-feedback" v-if="$v.surcharge.type.$error"
            >Select a Event</small
          >
        </div>

        <div class="col-lg-6 col-sm-4 col-4">
          <label class="title-label ml-0">Active</label>
          <base-switch v-model="surcharge.status" class="mt-2"></base-switch>
        </div>

        <div
          class="col-lg-3 col-sm-6 col-6"
          v-show="!['weekend_dates', 'night_fees'].includes(surcharge.type)"
        >
          <base-input label="From Date" markrequired>
            <flat-picker
              slot-scope="{ focus, blur }"
              @on-open="focus"
              @on-close="blur"
              :config="{
                altFormat: 'd-M-Y',
                altInput: true,
                minDate: 'today',
                dateFormat: 'Y-m-d',
                allowInput: true
              }"
              class="input-custom"
              v-model="surcharge.from_date"
              id="from_date"
              name="from_date"
              placeholder="From date"
              markrequired
            ></flat-picker>
          </base-input>
        </div>

        <div
          class="col-lg-3 col-sm-6 col-6"
          v-if="
            ![
              'blackouts',
              'availability_on_request',
              'weekend_dates',
              'seasonal'
            ].includes(surcharge.type)
          "
        >
          <base-input label="Start Time">
            <flat-picker
              slot-scope="{ focus, blur }"
              @on-open="focus"
              @on-close="blur"
              :config="{
                enableTime: true,
                altInput: true,
                noCalendar: true,
                altFormat: 'G:i K',
                dateFormat: 'G:i K',
                time_24hr: false,
                wrap: true
              }"
              class="input-custom"
              v-model="surcharge.start_time"
              id="new-start-fromtime"
              name="new-start-fromtime"
              placeholder="Start Time"
            ></flat-picker>
          </base-input>
        </div>

        <div
          class="col-lg-3 col-sm-6 col-6"
          v-if="
            ![
              'blackouts',
              'availability_on_request',
              'weekend_dates',
              'seasonal'
            ].includes(surcharge.type)
          "
        >
          <base-input label="End Time">
            <flat-picker
              slot-scope="{ focus, blur }"
              @on-open="focus"
              @on-close="blur"
              :config="{
                enableTime: true,
                altInput: true,
                noCalendar: true,
                altFormat: 'G:i K',
                dateFormat: 'G:i K',
                time_24hr: false,
                wrap: true
              }"
              class="input-custom"
              v-model="surcharge.end_time"
              id="new-end-fromtime"
              name="new-end-fromtime"
              placeholder="End Time"
            ></flat-picker>
          </base-input>
        </div>
        <div class="col-lg-6 mb-4" v-if="surcharge.type === 'seasonal'">
          <label for class="title-label">Ends</label>

          <div class="row">
            <div class="col-lg-3 col-sm-4 col-4 align-self-center">
              <base-radio
                class="mr-5 ml-3"
                name="on"
                value="on"
                v-model="customEnd"
                >On</base-radio
              >
            </div>
            <div class="col-lg-7 col-sm-6 col-8 align-self-center">
              <base-input class="mb-0 mt-2">
                <flat-picker
                  slot-scope="{ focus, blur }"
                  @on-open="focus"
                  @on-close="blur"
                  :config="{
                    altFormat: 'd-M-Y',
                    altInput: true,
                    dateFormat: 'Y-m-d',
                    allowInput: true
                  }"
                  class="input-custom"
                  v-model="surcharge.to_date"
                  id="EditendOn"
                  name="EditendOn"
                  :disabled="!(customEnd === 'on')"
                  placeholder="End On"
                ></flat-picker>
              </base-input>
            </div>
          </div>
        </div>
        <div
          class="col-lg-3 col-sm-6 col-6"
          v-if="
            ![
              'blackouts',
              'availability_on_request',
              'weekend_dates',
              'night_fees'
            ].includes(surcharge.type)
          "
        >
          <label class="title-label ml-0">Frecuency Yearly</label>
          <base-switch v-model="surcharge.frequency" class="mt-2"></base-switch>
        </div>

        <div
          class="col-lg-6 mb-4"
          v-if="
            !['weekend_dates', 'night_fees', 'seasonal'].includes(
              surcharge.type
            )
          "
        >
          <label for class="title-label">Ends</label>

          <div class="row">
            <div
              class="col-lg-12 col-sm-12 col-12"
              v-if="
                ['blackouts', 'availability_on_request'].includes(
                  surcharge.type
                )
              "
            >
              <base-radio
                class="mr-5 ml-3 mt-3"
                name="never"
                value="never"
                v-model="customEnd"
                >Never</base-radio
              >
            </div>

            <div class="col-lg-3 col-sm-4 col-4 align-self-center">
              <base-radio
                class="mr-5 ml-3 mt-2"
                name="on"
                value="on"
                v-model="customEnd"
                >On</base-radio
              >
            </div>
            <div class="col-lg-7 col-sm-6 col-8 align-self-center">
              <base-input class="mb-0">
                <flat-picker
                  slot-scope="{ focus, blur }"
                  @on-open="focus"
                  @on-close="blur"
                  :config="{
                    altFormat: 'd-M-Y',
                    altInput: true,
                    minDate: 'today',
                    dateFormat: 'Y-m-d',
                    allowInput: true
                  }"
                  class="input-custom"
                  v-model="surcharge.to_date"
                  id="endOn"
                  name="endOn"
                  :disabled="!(customEnd === 'on')"
                  placeholder="End On"
                ></flat-picker>
              </base-input>
            </div>
          </div>
        </div>

        <div class="col-lg-12">
          <div class="row">
            <div
              class="col-lg-4 col-sm-4 col-4 switch-sm"
              v-if="
                !['blackouts', 'availability_on_request'].includes(
                  surcharge.type
                )
              "
            >
              <label class="title-label ml-0">Surcharge</label>

              <base-switch
                v-model="markupType"
                onText="%"
                offText="$"
                class="mt-2"
                @input="chnageMarkupType"
              ></base-switch>
            </div>

            <div
              class="col-lg-4 col-sm-4 col-4 align-self-start"
              v-if="
                !['blackouts', 'availability_on_request'].includes(
                  surcharge.type
                )
              "
            >
              <label class="title-label d-block">Value</label>
              <BaseNumberInput
                id="event_valueMarkup"
                name="event_valueMarkup"
                placeholder="Value Markup"
                v-model.number="surcharge.markup.value"
              />
            </div>

            <div
              class="col-lg-4 col-sm-4 col-4 switch-lg"
              v-if="
                !['blackouts', 'availability_on_request'].includes(
                  surcharge.type
                )
              "
            >
              <label class="title-label ml-0">Apply in</label>
              <base-switch
                v-model="markupApplyIn"
                onText="Gross"
                offText="Net"
                class="mt-2"
                @input="changeMarkupApplyIn"
              ></base-switch>
            </div>

            <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
              <div
                v-bind:class="{
                  'is-invalid': $v.surcharge.description.$error
                }"
              >
                <label class="title-label"
                  ><span class="markrequired">*</span>Description</label
                >

                <el-input
                  v-model="surcharge.description"
                  placeholder="Type something here..."
                  id="description"
                  name="description"
                  maxlength="200"
                  type="textarea"
                  :autosize="{ minRows: 2, maxRows: 5 }"
                  show-word-limit
                >
                </el-input>
              </div>
              <small
                class="invalid-feedback"
                v-if="$v.surcharge.description.$error"
                >Enter Min. 8 Characters</small
              >
            </div>
          </div>
        </div>

        <div class="col-12 alinmov2 mt-2">
          <base-button
            type="primary"
            class="min-button mb-0"
            :disabled="loadingRequest"
            @click="saveSurcharge()"
          >
            <i class="flaticon-floppy-disk"></i>Save
          </base-button>
        </div>
      </div>
    </div>

    <template slot="footer"> </template>
  </modal>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
import flatPicker from "vue-flatpickr-component";
import { SurchargesAPI } from "../../../core/api";
import "flatpickr/dist/flatpickr.css";
import moment from "moment-timezone";
import { DatePicker, TimeSelect } from "element-ui";
import lodash from "lodash";
import { required, minLength } from "vuelidate/lib/validators";
import WSelect from "@/components/Select";
import { SURCHARGE_TYPES } from "../constants/surcharge.constants";

WSelect.computed.readonly = function() {
  const isIE = !this.$isServer && !Number.isNaN(Number(document.documentMode));
  return (
    !this.filterable ||
    this.multiple ||
    (!isIE && !this.visible && !this.remote)
  );
};

export default {
  name: "NewSurcharge",
  props: {
    show: {
      type: Boolean,
      default: false
    },
    timezone: {
      type: String,
      required: true
    },
    limit: {
      type: Array,
      required: true
    },
    surchargeId: {
      type: [String, null],
      default: null
    }
  },
  data() {
    return {
      surcharge: {
        type: "blackouts",
        status: true,
        from_date: moment().format("YYYY-MM-DD"),
        start_time: "12:00 PM",
        to_date: moment()
          .add(7, "days")
          .format("YYYY-MM-DD"),
        end_time: "12:00 PM",
        markup: {
          type: "percentage",
          value: 0,
          apply_in: "gross"
        },
        frequency: false,
        custom_frecuency: "",
        description: "",
        custom: {
          repeat_every: 1,
          repeat_frecuency: "day",
          repeat_on: {
            monday: false,
            tuesday: false,
            wednesday: false,
            thursday: false,
            friday: false,
            saturday: false,
            sunday: false
          },
          end: false,
          end_on_date: moment().format(""),
          end_on: true,
          end_after: 1,
          end_after_active: false
        }
      },
      markupType: true,
      markupApplyIn: true,
      openModal: false,
      SURCHARGE_TYPES,
      customEnd: "on",
      loadingRequest: false
    };
  },
  created() {},
  watch: {
    show: {
      handler: function(current, old) {
        this.openModal = current;
      },
      deep: true
    },
    customEnd: function(newVal, oldVal) {
      if (newVal === "on") {
        this.surcharge.custom.end_after_active = false;
        this.surcharge.custom.end = false;
        this.surcharge.custom.end_on = true;
      } else if (newVal === "never") {
        this.surcharge.custom.end_after_active = false;
        this.surcharge.custom.end = true;
        this.surcharge.custom.end_on = false;
      } else if (newVal === "after") {
        this.surcharge.custom.end_after_active = true;
        this.surcharge.custom.end = false;
        this.surcharge.custom.end_on = false;
      }
    },
    surchargeId: {
      handler: function(current, old) {
        if (current) {
          this.duplicateSurchargeById(current);
        }
      },
      deep: true
    }
  },
  methods: {
    closeSurchargeModal() {
      this.$emit("closeSurchargeModal", false);
      this.resertSurchargeData();
    },
    resertSurchargeData() {
      this.surcharge.type = "blackouts";
      this.surcharge.status = true;
      this.surcharge.from_date = moment().format("YYYY-MM-DD");
      this.surcharge.start_time = "12:00 PM";
      this.surcharge.to_date = moment().format("YYYY-MM-DD");
      this.surcharge.end_time = "12:00 PM";
      this.surcharge.markup.type = "percentage";
      this.surcharge.markup.value = 0;
      this.surcharge.markup.apply_in = "gross";
      this.surcharge.frequency = false;
      this.surcharge.custom_frecuency = "";
      this.surcharge.description = "";
      this.surcharge.custom.repeat_every = 0;
      this.surcharge.custom.repeat_frecuency = "week";
      this.surcharge.custom.repeat_on.monday = false;
      this.surcharge.custom.repeat_on.tuesday = false;
      this.surcharge.custom.repeat_on.wednesday = false;
      this.surcharge.custom.repeat_on.thursday = false;
      this.surcharge.custom.repeat_on.friday = false;
      this.surcharge.custom.repeat_on.saturday = false;
      this.surcharge.custom.repeat_on.sunday = false;
      this.surcharge.custom.end = false;
      this.surcharge.custom.end_on = true;
      this.surcharge.custom.end_on_date = moment().format("YYYY-MM-DD");
      this.surcharge.custom.end_after = 0;
      this.surcharge.custom.end_after_active = false;
      this.markupApplyIn = true;
      this.markupType = true;
      this.loadingRequest = false;
      this.$v.surcharge.$reset();
    },
    onlyNightlyFee(surcharges = []) {
      return (
        surcharges.filter(surcharge => surcharge.type === "night_fees").length <
        2
      );
    },
    onlyWeekendFee(surcharges = []) {
      return (
        surcharges.filter(surcharge => surcharge.type === "weekend_dates")
          .length < 1
      );
    },
    saveSurcharge() {
      if (!this.$v.surcharge.$invalid) {
        let surcharge = lodash.cloneDeep(this.surcharge);

        const onlyNightly = this.onlyNightlyFee(this.limit);
        if (surcharge.type === "night_fees" && !onlyNightly) {
          this.$notify({
            type: "warning",
            title: "Important!",
            message: "You can only have two nightly events.",
            icon: "flaticon-warning-1"
          });
          return;
        }

        const onlyWeekend = this.onlyWeekendFee(this.limit);
        if (surcharge.type === "weekend_dates" && !onlyWeekend) {
          this.$notify({
            type: "warning",
            title: "Important!",
            message: "You can only have one weekend fee event.",
            icon: "flaticon-warning-1"
          });
          return;
        }

        this.createSurcharge(surcharge);
      } else {
        this.$v.surcharge.$touch();
        this.$notify({
          type: "warning",
          title: "Important!",
          message: "Please complete the required attributes",
          icon: "flaticon-warning-1"
        });
      }
    },
    async createSurcharge(surcharge) {
      try {
        this.loadingRequest = true;
        let { data } = await SurchargesAPI.createSurcharge(surcharge);
        this.loadingRequest = false;
        if (data) {
          this.$emit("addSurcharge", {
            status: true,
            surcharge: data
          });
          this.resertSurchargeData();
        } else {
          this.$notify({
            type: "danger",
            title: "Error!",
            message: "The Operation couldn't be completed. Please try again",
            icon: "flaticon-remove"
          });
        }
      } catch (error) {
        this.loadingRequest = false;
        this.$notify({
          type: "danger",
          title: "Error!",
          message: "The Operation couldn't be completed. Please try again",
          icon: "flaticon-remove"
        });
      }
    },
    chnageMarkupType(value) {
      this.surcharge.markup.type = value ? "percentage" : "money";
    },
    changeMarkupApplyIn(value) {
      this.surcharge.markup.apply_in = value ? "gross" : "net";
    },
    async duplicateSurchargeById(surchargeId) {
      try {
        let { data } = await SurchargesAPI.getSurchargeById(surchargeId);
        if (data) {
          let surcharge = data;
          this.surcharge.type = surcharge.type;
          this.surcharge.status = surcharge.status;
          this.surcharge.from_date = surcharge.from_date;
          this.surcharge.start_time = surcharge.start_time;
          this.surcharge.to_date = surcharge.to_date;
          this.surcharge.end_time = surcharge.end_time;
          this.surcharge.markup.type = surcharge.markup.type;
          this.surcharge.markup.value = surcharge.markup.value;
          this.surcharge.markup.apply_in = surcharge.markup.apply_in;
          this.surcharge.frequency = surcharge.frequency;
          this.surcharge.custom_frecuency = surcharge.custom_frecuency;
          this.surcharge.description = surcharge.description;
          this.surcharge.custom = lodash.cloneDeep(surcharge.custom);
        } else {
          this.$notify({
            type: "danger",
            title: "Error!",
            message: "The Operation couldn't be completed. Please try again",
            icon: "flaticon-remove"
          });
        }
      } catch (error) {
        this.$notify({
          type: "danger",
          title: "Error!",
          message: "The Operation couldn't be completed. Please try again",
          icon: "flaticon-remove"
        });
      }
    },
    ...mapMutations(["setLoad"])
  },
  computed: {
    ...mapGetters(["sesion"])
  },
  components: {
    [DatePicker.name]: DatePicker,
    [TimeSelect.name]: TimeSelect,
    flatPicker,
    WSelect
  },
  validations: {
    surcharge: {
      type: {
        required
      },
      description: {
        required,
        minLength: minLength(8)
      }
    }
  }
};
</script>
